/* UKL: click-to-copy SKU on product cards + product page */
(function(){
  var SEL='[data-card-sku-value], .product-sku__value';
  function copyText(t){
    if(navigator.clipboard && window.isSecureContext){return navigator.clipboard.writeText(t);}
    return new Promise(function(res,rej){try{var ta=document.createElement('textarea');ta.value=t;ta.setAttribute('readonly','');ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);res();}catch(e){rej(e);}});
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest(SEL); if(!el) return;
    e.preventDefault(); e.stopPropagation();
    var t=(el.textContent||'').trim(); if(!t) return;
    copyText(t).then(function(){
      el.setAttribute('data-copied','1');
      setTimeout(function(){el.removeAttribute('data-copied');},1400);
    });
  },true);
  function label(){document.querySelectorAll(SEL).forEach(function(el){if(!el.title)el.title='Click to copy SKU';});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',label);else label();
  document.addEventListener('shopify:section:load',label);
})();
